import { useEffect, useState } from 'react';
import selectorService, { SelectionItem } from '@/core/services/SelectorService';

export function useAvailableSelections(): [SelectionItem[], boolean] {
  const [items, setItems] = useState<SelectionItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    selectorService
      .getSelections()
      .then((res) => { if (active) setItems(res.selections); })
      .catch((error) => {
        console.error('Error fetching available selections:', error);
        if (active) setItems([]);
      })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  return [items, loading];
}
